var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ExportMenu } from '@web/components/layout/ExportMenu/ExportMenu';
import Loading from '@web/components/layout/Loading';
import { AppsMultiSeriesBarChart } from '@web/components/layout/RechartsItems/AppsMultiSeriesBarChart';
import { ChartSeriesVisibility } from '@web/components/layout/RechartsItems/ChartSeriesVisibility';
import LegendItem from '@web/components/layout/RechartsItems/LegendItem';
import { Widget } from '@web/components/layout/Widget';
import { WidgetTitle } from '@web/components/layout/WidgetTitle/WidgetTitle';
import { CHART_COLOR_TOKEN_HEX, TablesDiffColorsConfig } from '@web/config';
import { trpc } from '@web/lib/trpc';
import { isAiButtonDisabled } from '@web/utility';
import { applyDayPeriodAxisNames } from '@web/utility/charts';
import { useFilters } from '@web/utility/hooks/useFilters';
import { InsightTypeEnum } from '@workalizer/shared/enums';
import { getInterval, getPercentageDiff, getPreviousPeriod } from '@workalizer/shared/utils';
import { useTranslation } from 'react-i18next';
var DOC_ALERTS_CHART_COLORS = {
    current: {
        color: 'bg-widgetBlue-500',
        chartColor: CHART_COLOR_TOKEN_HEX['widgetBlue-500']
    },
    previous: {
        color: 'bg-widgetBlue-300',
        chartColor: CHART_COLOR_TOKEN_HEX['widgetBlue-300']
    }
};
var AlertsSummaryChart = function () {
    var t = useTranslation().t;
    var _a = useFilters(), dateFrom = _a.dateFrom, dateTo = _a.dateTo, orgUnit = _a.orgUnit, user = _a.user;
    var interval = getInterval(dateFrom, dateTo);
    var _b = getPreviousPeriod(dateFrom, dateTo), prevPeriodDateFrom = _b.prevPeriodDateFrom, prevPeriodDateTo = _b.prevPeriodDateTo;
    var _c = trpc.alertsSummary.useQuery({
        dateFrom: dateFrom,
        dateTo: dateTo,
        orgUnitId: orgUnit,
        triggeredBy: user,
        groupBy: interval
    }), data = _c.data, isLoading = _c.isLoading, refetch = _c.refetch;
    var _d = trpc.alertsSummary.useQuery({
        dateFrom: prevPeriodDateFrom,
        dateTo: prevPeriodDateTo,
        orgUnitId: orgUnit,
        triggeredBy: user,
        groupBy: interval
    }), prevPeriodData = _d.data, isPrevPeriodLoading = _d.isLoading, refetchPrevPeriod = _d.refetch;
    if (isLoading || isPrevPeriodLoading || !data || !prevPeriodData) {
        return _jsx(Loading, {});
    }
    var alertsSeriesLabel = t('docAlerts.docAlerts');
    var previousPeriodLabel = t('tooltip.periodComparison.previousPeriod');
    var rawChartData = data.map(function (item, index) {
        var _a;
        var _b, _c;
        return (_a = {
                name: item.date
            },
            _a[previousPeriodLabel] = (_c = (_b = prevPeriodData[index]) === null || _b === void 0 ? void 0 : _b.count) !== null && _c !== void 0 ? _c : 0,
            _a[alertsSeriesLabel] = item.count,
            _a);
    });
    var chartDataForDisplay = applyDayPeriodAxisNames(rawChartData, interval, {
        dateFrom: dateFrom,
        dateTo: dateTo
    });
    var categories = [previousPeriodLabel, alertsSeriesLabel];
    var colors = [
        DOC_ALERTS_CHART_COLORS.previous.chartColor,
        DOC_ALERTS_CHART_COLORS.current.chartColor
    ];
    var totalAlerts = data.reduce(function (sum, item) { return sum + item.count; }, 0);
    var prevTotalAlerts = prevPeriodData.reduce(function (sum, item) { return sum + item.count; }, 0);
    var alertsDiff = getPercentageDiff(prevTotalAlerts, totalAlerts);
    return (_jsxs("div", { children: [_jsx(WidgetTitle, { title: "insights.tables.docAlertsChart", description: "widgetTitleDescriptions.apps.docAlertsChart", insightType: InsightTypeEnum.docAlertsChart, insightsData: chartDataForDisplay, refetch: function () {
                    refetch();
                    refetchPrevPeriod();
                }, labels: categories, csvExport: _jsx(ExportMenu, { fileName: t('insights.tables.docAlertsChart'), onExportHandler: function () { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, chartDataForDisplay.map(function (row) {
                                    var _a;
                                    var _b, _c;
                                    return (_a = {},
                                        _a[t('export.date')] = row.name,
                                        _a[previousPeriodLabel] = (_b = row[previousPeriodLabel]) !== null && _b !== void 0 ? _b : 0,
                                        _a[alertsSeriesLabel] = (_c = row[alertsSeriesLabel]) !== null && _c !== void 0 ? _c : 0,
                                        _a);
                                })];
                        });
                    }); }, disabled: isAiButtonDisabled(chartDataForDisplay) }) }), _jsx(ChartSeriesVisibility, __assign({ seriesKeys: categories }, { children: function (_a) {
                    var hiddenSeries = _a.hiddenSeries, toggleSeries = _a.toggleSeries, isSeriesVisible = _a.isSeriesVisible;
                    return (_jsxs(Widget, { children: [_jsxs("div", __assign({ className: "mb-6 ml-2 flex flex-wrap justify-start gap-8 rounded-lg p-4 lg:gap-8" }, { children: [_jsx(LegendItem, { color: DOC_ALERTS_CHART_COLORS.current.color, label: alertsSeriesLabel, currentValue: totalAlerts, diffValue: alertsDiff, arrowColor: TablesDiffColorsConfig.GREEN, onClick: function () { return toggleSeries(alertsSeriesLabel); }, isHidden: !isSeriesVisible(alertsSeriesLabel) }), _jsx(LegendItem, { color: DOC_ALERTS_CHART_COLORS.previous.color, label: previousPeriodLabel, currentValue: prevTotalAlerts, onClick: function () { return toggleSeries(previousPeriodLabel); }, isHidden: !isSeriesVisible(previousPeriodLabel) })] })), _jsx("div", __assign({ className: "w-full min-w-0 pt-1" }, { children: _jsx(AppsMultiSeriesBarChart, { data: chartDataForDisplay, categories: categories, colors: colors, interval: interval, dateFrom: dateFrom, dateTo: dateTo, variant: "grouped", showLegend: false, chartHeight: 340, hiddenCategories: hiddenSeries }) }))] }));
                } }))] }));
};
export default AlertsSummaryChart;
